/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';
import { TABLE_BASKET_ITEM_SIZE } from './constants';

export const BasketModalTitleCounterStyled = styled.div`
    display: inline-flex;
    align-items: center;
    height: 32px;
    margin-left: 8px;
    padding: 0 10px;
    border-radius: 15.5px;
    background: ${colors.basketModuleBg};
    ${fonts.textMain}
`;

export const BasketModalContainerStyled = styled.div`
    padding: 0 24px;
`

export const BasketModalListStyled = styled(BasketModalContainerStyled)`
    background: ${colors.basketItemBg};
    max-height: 440px;
    overflow: auto;
`

export const BasketModalItemStyled = styled.div`
    height: ${TABLE_BASKET_ITEM_SIZE}px;
    padding: 10px;
    box-sizing: border-box;
    &:not(:last-child) {
        border-bottom: 1px solid ${colors.basketItemBorder};
    }
`
